export default __webpack_public_path__ + "static/media/h100.a283de57.png";